import { Seo, breadcrumbSchema } from "@/components/layout/Seo";
import { PageHero, Reveal } from "@/components/ui/motion";
import { FaqList } from "@/components/sections/FaqSection";
import { ConsultForm } from "@/components/sections/ConsultForm";
import { FAQS } from "@/data/faqs";

export default function FaqPage() {
  const crumbs = [{ to: "/", label: "Beranda" }, { to: "/faq", label: "FAQ" }];
  const faqSchema = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) };
  return (
    <>
      <Seo title="FAQ Konsultasi Penyelesaian Utang | Mika Solution" description="Jawaban atas pertanyaan umum seputar layanan konsultasi dan pendampingan penyelesaian kewajiban pinjol, kartu kredit, dan KTA di Mika Solution." path="/faq" schema={[faqSchema, breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Pertanyaan Umum" lines={["Ada yang Ingin", <span className="serif-it font-normal text-accentb">Ditanyakan?</span>]} desc="Kami merangkum pertanyaan yang paling sering diajukan sebelum konsultasi." />
      <section className="py-16 sm:py-24" data-testid="faq-page">
        <Reveal className="wrap max-w-4xl"><FaqList /></Reveal>
      </section>
      <ConsultForm />
    </>
  );
}
